import { gql } from '../../../apollo/__generated__';

export const USERS = gql(`
  query Users {
    users {
      id
      firstname
      lastname
      nickname
      folklore
      email
      roles {
        name
        givenByUser {
          id
          firstname
          lastname
          email
        }
      }
    }
  }
`);
